<template lang="pug">
    .concurs_intro
        .video
            video(autoplay="autoplay" muted="muted" playsinline loop data-object-fit="cover")
                source( :src="require('@/assets/video/concurs_video.mp4')" type="video/mp4")
        .content(:style="{paddingTop: isMobileDevice && deviceHeight / 100 *9.6+'px'}")
            h2(v-html="'Круиз на&nbsp;Северный полюс на&nbsp;атомном ледоколе'" :style="{fontSize: isMobileDevice && deviceHeight / 100 *8.8+'px'}")
            .text(:style="{fontSize: isMobileDevice && deviceHeight / 100 *2+'px', paddingTop: isMobileDevice && deviceHeight / 100 *2.5+'px'}")
                p Северный полюс — одно из самых удивительных мест на нашей планете. Только представьте себе путешествие в это Королевство снега и льда. Здесь вы сможете <nobr>по-настоящему</nobr> вдохнуть полной грудью свежий полярный воздух, увидеть редких животных, дрейфующие многолетние льды и сделать незабываемые фотографии на самой «Вершине мира».
                p Наша экспедиция отправится на Северный полюс из города Мурманск на самом большом и современном арктическом атомоходе - «50 лет Победы». В рамках круиза мы достигнем Северного полюса, а так же пройдем водами Арктики к самой Северной точке России – легендарному архипелагу Земля Франца-Иосифа. На экспедиционных лодках Зодиак высадимся на живописные берега, соприкоснёмся с самобытной природой, осмотрим Арктику с высоты птичьего полета с борта вертолета.
            .flipping(:style="{marginTop: isMobileDevice && deviceHeight / 100 * 3+'px'}") листайте
                img(v-if="!isMobileDevice" src="@/assets/img/flipping_icon.png" alt="")
                img(v-else="" src="@/assets/img/flipping_icon-mobile.png" alt="")
</template>

<script>
    export default {
        name: "Intro",
        computed: {
            isMobileDevice() {
                return this.$store.state.isMobileDevice;
            },
            deviceHeight() {
                return this.$store.state.deviceHeight
            },
        },
        mounted() {
            objectFitPolyfill(); // for IE, Edge
        },
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .concurs_intro {
        display: flex;
        justify-content: flex-end;
        overflow: hidden;
        color: #fff;

        .video {
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            width: 76vw;
            height: 100%;
            background: #000;
        }

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 0.5;
            @include portrait {
                width: initial;
                height: 100vh;
            }
        }

        .content {
            position: relative;
            height: 100%;
            width: 51%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16vh 5vw 0 0;

            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: -3.6vw;
                right: 0;
                bottom: 0;
                background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(30, 130, 245) 100%);
                transform: skewX(-28.5deg);
                transform-origin: 0 100%;
            }

            h2, .text, .flipping {
                position: relative;
            }

            h2 {
                width: 100%;
                font-size: 7vw;
                //font-size: 8.4rem;
                letter-spacing: -0.5px;
                line-height: 0.9;
                font-weight: bold;
            }

            .text {
                width: 100%;
                padding: 4vh 1vw 0 9.4vw;
                font-family: 'Fira Sans Extra Condensed', sans-serif;
                font-size: 0.89vw;
                line-height: 1.3;

                p {
                    margin-bottom: 1.5vh;
                }
            }

            .flipping {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 1.7vh 0 0 3.5vw;
                font-size: 1rem;
                font-weight: bold;

                img {
                    margin-top: 0.5vh;
                    width: 1rem;
                }
            }
        }
    }

    .mobile .concurs_intro {
        .video {
            width: 100vw;

            &:after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba($blue, 0.55);
            }
        }

        .content {
            width: 100vw;
            padding: 0 0 0;
            text-align: center;

            h2 {
                padding: 0 13vw;
                //font-size: 8.8vh;
                line-height: 0.94;
            }

            .text {
                padding: 0 5vw;
                //font-size: 1.85vh;
                line-height: 1.34;

                p {
                    display: inline;
                    margin-bottom: 0;
                }
            }

            .flipping {
                margin: 0;
                font-size: 1.7vh;

                img {
                    width: 1.7vh;
                }
            }

            &:before {
                top: 54%;
                transform: skewY(-22.5deg);
                transform-origin: 100% 100%;
                background-image: linear-gradient(54deg, #002277 0%, #1e82f5 100%);
            }
        }
    }
</style>
